import * as React from 'react';
import { DialogProvider, DialogSurfaceProvider } from '../../contexts';
/**
 * Render the final JSX of Dialog
 */

export const renderDialog_unstable = (state, contextValues) => {
  const {
    content,
    trigger
  } = state;
  return /*#__PURE__*/React.createElement(DialogProvider, {
    value: contextValues.dialog
  }, /*#__PURE__*/React.createElement(DialogSurfaceProvider, {
    value: contextValues.dialogSurface
  }, trigger, content));
};
//# sourceMappingURL=renderDialog.js.map